module.exports = __webpack_public_path__ + "img/Transit Lane Where.855a3172.jpg";